import { AmountBar } from '@/components/AmountBar';
import { Container } from '@/components/Container';
import { prettifyPercentage } from '@/utils/prettifyPercentage';

export const PercentageDisplay = ({ percent }: { percent: number }) => {
  return (
    <Container
      debugColor={'gray'}
      sx={{
        height: '100%',
        minHeight: '100%',
        textAlign: 'center',
        flexGrow: 0,
        justifyContent: 'center',
        alignItems: 'center',
        width: 120,
      }}
    >
      <Container
        position={'absolute'}
        debugColor={'gray'}
        sx={{ height: '100%', justifyContent: 'center', alignItems: 'center', textAlign: 'left', flexGrow: 1 }}
      >
        <AmountBar paidAmount={percent} openAmount={100 - percent} height={'100%'} />
      </Container>
      <Container
        debugColor={'gray'}
        sx={{
          height: '100%',
          color: 'white',
          fontWeight: 'bold',
          fontSize: 12,
          textAlign: 'center',
          flexGrow: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {prettifyPercentage(percent)}
      </Container>
    </Container>
  );
};
